import type { RootState } from '@state/index.ts';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import Modals from './Modals.tsx';
import GlobalStyles from './components/styled/GlobalStyles.ts';
import PageLayout from './pageLayout/index.tsx';
import Routes from './pages/index.tsx';
import theme from './theme.ts';

export function App() {
  const mobileView = useSelector((state: RootState) => state.config.mobileView);

  if (mobileView) {
    return (
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Routes />
      </ThemeProvider>
    );
  }
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Modals />
      <PageLayout>
        <Routes />
      </PageLayout>
    </ThemeProvider>
  );
}
